import {SupportContactFormService} from "webform/gen/supportContactForm";
import {BrandEnum} from "utils/brand";
import {UserPersona} from "webform/gen/supportContactForm/models/UserPersona";
import {notify} from "config/sentry";
import {ErrorType} from "config/errors";

import {DEEPLINK_PREFIXES, MobileApp} from "webform/utils/deeplinkPrefixes";

export {MobileApp};

export const webformUserPersonaToMobileAppMap: {[key in UserPersona]?: MobileApp} = {
    [SupportContactFormService.UserPersona.CAR_RENTAL]: MobileApp.RIDER,
    [SupportContactFormService.UserPersona.EBIKE]: MobileApp.RIDER,
    [SupportContactFormService.UserPersona.MARKET_CONSUMER]: MobileApp.RIDER,
    [SupportContactFormService.UserPersona.RIDER]: MobileApp.RIDER,
    [SupportContactFormService.UserPersona.SCOOTERS]: MobileApp.RIDER,
};

export enum DeeplinkAction {
    OPEN_SUPPORT = "open_support",
}

export const generateDeeplink = (
    action: DeeplinkAction,
    mobileApp: MobileApp,
    brand?: BrandEnum,
): {navigate: () => void; url: string} | undefined => {
    const DEEPLINK_ACTIONS: Record<DeeplinkAction, string> = {
        [DeeplinkAction.OPEN_SUPPORT]: "action/support",
    };

    if (!brand) {
        return undefined;
    }

    const prefix = DEEPLINK_PREFIXES[brand][mobileApp];

    if (!prefix) {
        notify("Missing deeplink prefix", ErrorType.CONFIG_MISSING_DEEPLINK_PREFIX, {
            mobileApp,
            action,
        });
    }

    const url = `${prefix}://${DEEPLINK_ACTIONS[action]}`;

    return {
        navigate: () => window.location.replace(url),
        url,
    };
};
